import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Films from "@/pages/Films";
import FilmDetail from "@/pages/FilmDetail";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Wholesale from "@/pages/Wholesale";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import AdminDenied from "@/pages/AdminDenied";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import StickyCTA from "@/components/StickyCTA";
import MobileCallButton from "@/components/MobileCallButton";

function AppRouter() {
  const location = useLocation();

  return (
    <>
      {location.hash?.includes("session_id=") ? (
        <AuthCallback />
      ) : (
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/pellicules" element={<Films />} />
            <Route path="/pellicules/miroir" element={<FilmDetail filmKey="miroir" />} />
            <Route path="/pellicules/givre" element={<FilmDetail filmKey="givre" />} />
            <Route path="/pellicules/securite" element={<FilmDetail filmKey="securite" />} />
            <Route path="/services" element={<Services />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/grossiste" element={<Wholesale />} />
            <Route path="/wholesale" element={<Wholesale />} />
            <Route path="/pellicule-miroir" element={<ServicePage pageKey="miroir" />} />
            <Route path="/pellicule-anti-chaleur" element={<ServicePage pageKey="anti-chaleur" />} />
            <Route path="/pellicule-anti-uv" element={<ServicePage pageKey="anti-uv" />} />
            <Route path="/pellicule-intimite-fenetre" element={<ServicePage pageKey="intimite" />} />
            <Route path="/pellicule-givree" element={<ServicePage pageKey="givree" />} />
            <Route path="/pellicule-fenetre-montreal" element={<CityPage fixedCity="montreal" />} />
            <Route path="/pellicule-fenetre-laval" element={<CityPage fixedCity="laval" />} />
            <Route path="/pellicule-fenetre-longueuil" element={<CityPage fixedCity="longueuil" />} />
            <Route path="/pellicule-fenetre-brossard" element={<CityPage fixedCity="brossard" />} />
            <Route path="/conseils" element={<Blog />} />
            <Route path="/conseils/:slug" element={<BlogPost />} />
            <Route path="/secteurs/montreal" element={<Navigate to="/pellicule-fenetre-montreal" replace />} />
            <Route path="/secteurs/:city" element={<CityPage />} />
            <Route path="/confidentialite" element={<PrivacyPolicy />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/denied" element={<AdminDenied />} />
        </Routes>
      )}
      <StickyCTA />
      <MobileCallButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
